export const CONFS = {
  syyd: {
    totalFrames: 499,
    duration: 17.1,
    audio: "syyd"
  },
  syyddaiji: {
    totalFrames: 21,
    duration: 1.7,
    loop: true,
    autoplay:false
  },
  jgc: {
    totalFrames: 250,
    duration: 10.3,
    audio: "jgc"
  },
  hg: {
    totalFrames: 38,
    duration: 2,
    width: 300,
    height: 316,
    loop: true
  },
  hgyw: {
    totalFrames: 38,
    duration: 2,
    loop: true,
    height: 112.44444444444444,
    pagesize:90
  },
  rndaiji: {
    totalFrames: 24,
    duration: 2.5,
    width: 300,
    height: 316,
    loop: true
  },
  rn: {
    totalFrames: 48,
    duration: 1.5,
    width: 300,
    height: 316,
    loop: true
  },
  rnhand: {
    totalFrames: 48,
    duration: 2.5,
    loop: true,
    height: 129
  },
};